var map = {
	"./airplane.png": 5026,
	"./berkut.png": 5394,
	"./bg1.png": 3824,
	"./bg2.png": 7913,
	"./bg3.png": 1425,
	"./bg4.png": 5303,
	"./bg5.png": 323,
	"./bg6.png": 6188,
	"./bg7.png": 8681,
	"./bicycle-lamp.png": 4178,
	"./chasy.png": 9993,
	"./kostotryas.png": 3915,
	"./lamp.png": 8207,
	"./lightning-detector.png": 5398,
	"./microscope.png": 620,
	"./phenomobile.png": 904,
	"./russo-balt.png": 1892,
	"./space-suit.png": 4243,
	"./steam-engine.png": 1646,
	"./tricycle.png": 1532,
	"./typewriter.png": 9841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;